module.exports = __webpack_public_path__ + "static/media/ICONS_WBN_CONTACTS.f92c8df3.svg";